var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import { HandleError } from '../../modules/utils/HandleError';
import { MunicipioApi } from '../../apis/municipio-api';
import { DefaultAutoComplete, DefaultAutoCompleteProps } from '../DefaultAutoComplete';
import { nonNull } from '../../util/CommonUtils';
var MunicipioSelectorProps = /** @class */ (function (_super) {
    __extends(MunicipioSelectorProps, _super);
    function MunicipioSelectorProps() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MunicipioSelectorProps;
}(DefaultAutoCompleteProps));
export { MunicipioSelectorProps };
export var MunicipioSelector = function (_a) {
    var _b = _a.placeholder, placeholder = _b === void 0 ? "Selecione um Munic\u00EDpio" : _b, onMunicipiosChange = _a.onMunicipiosChange, _c = _a.position, position = _c === void 0 ? 'start' : _c, noOptionsText = _a.noOptionsText, defaultValue = _a.defaultValue, otherOption = _a.otherOption, fieldError = _a.fieldError, onChange = _a.onChange, disabled = _a.disabled, required = _a.required, label = _a.label, value = _a.value, name = _a.name, uf = _a.uf, ufs = _a.ufs;
    //region Constants
    var _d = useState("".concat(crypto.getRandomValues(new Uint8Array(16)))), key = _d[0], setKey = _d[1];
    var _e = useState([]), municipios = _e[0], setMunicipios = _e[1];
    var _f = useState(), error = _f[0], setError = _f[1];
    //endregion
    //region Hooks
    useEffect(function () {
        handleSearchMun();
        setKey("".concat(crypto.getRandomValues(new Uint8Array(16))));
    }, []);
    useEffect(function () {
    }, [value, uf, key]);
    useEffect(function () {
        if (onMunicipiosChange) {
            onMunicipiosChange(__spreadArray([], municipios, true));
        }
    }, [municipios]);
    //endregion
    //region Handles
    var municipiosMemo = useMemo(function () {
        if (Array.isArray(ufs) && ufs.length > 0) {
            var ufsValues_1 = ufs.map(function (u) { return u.valueOf(); });
            return municipios.filter(function (it) {
                return ufsValues_1.includes(it === null || it === void 0 ? void 0 : it.uf) || (it === null || it === void 0 ? void 0 : it.nome) === (otherOption === null || otherOption === void 0 ? void 0 : otherOption.nome);
            });
        }
        var filtered = municipios;
        if (nonNull(uf)) {
            filtered = municipios.filter(function (it) { return (it === null || it === void 0 ? void 0 : it.uf) === (uf === null || uf === void 0 ? void 0 : uf.valueOf()); });
        }
        if (otherOption)
            return __spreadArray([otherOption], filtered, true);
        return filtered;
    }, [municipios, uf, otherOption]);
    var handleCloseError = function () {
        setError(undefined);
    };
    var handleSearchMun = function () {
        MunicipioApi.municipiosBr()
            .then(function (response) {
            if (otherOption) {
                setMunicipios(__spreadArray([otherOption], response, true));
            }
            else {
                setMunicipios(response);
            }
        })
            .catch(function (err) { return setError(err); });
    };
    //endregion
    var renderLabel = function (option) {
        return (option === null || option === void 0 ? void 0 : option.uf) && (option === null || option === void 0 ? void 0 : option.nome) ? "".concat(option.uf, " - ").concat(option.nome) : (option === null || option === void 0 ? void 0 : option.nome) || '';
    };
    var handleChange = function (_municipio) {
        onChange === null || onChange === void 0 ? void 0 : onChange(_municipio);
    };
    return (_jsxs(_Fragment, { children: [_jsx(DefaultAutoComplete, { onChange: function (newValue) { return handleChange(newValue !== null && newValue !== void 0 ? newValue : undefined); }, noOptionsText: noOptionsText !== null && noOptionsText !== void 0 ? noOptionsText : 'Nenhum município encontrado.', fieldsList: municipiosMemo, defaultValue: defaultValue, renderOption: renderLabel, comparablefield: 'codigo', placeholder: placeholder, otherOption: otherOption, fieldError: fieldError, value: value || null, name: name, position: position, disabled: disabled, required: required, label: label }), _jsx(HandleError, { error: error, handleClose: handleCloseError })] }));
};
